module.exports = __webpack_public_path__ + "static/media/notificationSuccess.a15d5b3f.svg";